import React from 'react';

import { Card, CardBody, CardHeader, CardTitle, CardText } from 'reactstrap';

import ReservationForm from './ReservationForm';

const BetaSignupCard = ({ showAlert = () => null }) => {
  return (
    <Card className="panel-card flex-fill rounded-3 border-primary-orange-subtle shadow-sm">
      <CardHeader className="panel-card-header surface-elevated text- rounded-top-3 border-0 border-bottom border-primary-orange-subtle">
        <CardTitle className="section-title text-center fw-normal m-0 text-capitalize bangers-regular sfb-title text-light">
          Claim Your Name
        </CardTitle>
      </CardHeader>

      <CardBody className="panel-card-body d-flex flex-column justify-content-around rounded-bottom-3 gap-3">
        <CardText className="section-subtitle text-center fw-medium text-secondary display-font mb-0">
          Secure your username now to make it yours before launch. Claiming it early ensures no one else can take your name and allows you to apply for a beta role.
        </CardText>

        <ReservationForm isModalContent={false} showAlert={showAlert} />

        <small className="d-block text-secondary text-center">
          Fast email verification and role-based beta access.
        </small>
      </CardBody>
    </Card>
  );
};

export default BetaSignupCard;
